module.exports = __webpack_public_path__ + "img/kverneland_ixdrive_s6.da0b42b5.jpg";